<template>
  <div class="content">
    <div class="set_wrap">
      <el-form ref="formdata" :model="formdata" label-width="140px" :rules="rules" label-position="left">
        <el-form-item label="佣金入账周期" prop="booked_cycle">
          <p>发货后
            <el-input v-model.number="formdata.booked_cycle" class="w80" size="small"></el-input>
            天
          </p>
          <p>*保存后即时生效，直销佣金与分销佣金都按照本设置入账。</p>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" size="small">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "withdrawalReview",
    data() {
      return {
        formdata: {
          booked_cycle: ''
        },
        rules: {
          booked_cycle: [
            {required: true, message: '1必填且为1-100', trigger: 'blur'},
            {type: 'number', message: '3必填且为1-100', trigger: 'blur'}
          ]
        }
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.withdraw_commission, this.formdata)
            .then(response => {
              if (response.data.code == 0) {
                this.formdata.booked_cycle = response.data.info.booked_cycle
              } else {
              }
            })
            .catch(response => {
            });
      },
      onSubmit() {
        let this_ = this
        this.$refs['formdata'].validate((valid) => {
          if (valid) {
            this_.axios
                .post(api.withdraw_commission_set, this_.formdata)
                .then(response => {
                  if (response.data.code == 0) {
                    this.$message({
                      message: '设置成功',
                    });
                    // this_.formdata.booked_cycle = response.data.info.booked_cycle
                  }
                })
                .catch(response => {
                });
          } else {
            return false;
          }
        });

      }
    }
  };
</script>
